var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"data-source":_vm.currentLayerDataSource,"layer":_vm.currentLayer,"lamp-id":_vm.lampId,"is-subfeature":_vm.isLampSubfeatureLayer}})}
var staticRenderFns = []

export { render, staticRenderFns }